/* src/app/private/configrations/pipeline-configuration/pipeline-configuration.component.scss */
.no-data {
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding: 20px;
}
.action-button {
  color: var(--primary-color);
  cursor: pointer;
  margin-left: 10px;
}
::ng-deep .pipeline-tabs .p-tabview-nav {
  background: transparent;
  border: none;
}
::ng-deep .pipeline-tabs .p-tabview-panels {
  background: transparent;
  padding: 1rem 0;
}
/*# sourceMappingURL=pipeline-configuration.component.css.map */
